// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4551) return "static/chunks/4551-78341c73f512d62e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3428":"5ae3aa30aca212b4","6383":"a44350d2430cd1ec","7874":"6ca5ce8d7a0c6abb"}[chunkId] + ".js";
};